import { atom } from "jotai";

// Primitive Atom storing whether the sidebar is open or not.
export const sidebarOpenAtom = atom(window.innerWidth > 700);

// The active link in the sidebar.
export const activeLinkAtom = atom<string | null>(null);

// MOBILE ONLY - Whether or not the Sidebar is in Workspace/Cloud switcher mode
export const switcherOpenAtom = atom(false);
